import type { FaireProductEntity } from "../../entity_types/product";

export const p_vr2vp77zbj: FaireProductEntity = {
  token: "p_vr2vp77zbj",
  type: "product",
  name: "Perfume de la Tierra",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/e1c5952919d3a83862c827f57b76c5bfbc082c792b167bd4c4ced71fcbbf92a6.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 36,
  description: "Perfume de la Tierra for wholesale.",
  tags: ["fragrance"],
  caseSize: 1,
  msrpDollars: 72,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
